import axios from 'axios';
import { API_URL, DJANGO_API_URL } from '../config';
import { openSnackbar } from './snackbar';

const sanitizeBase = (value) => {
  if (!value) return '';
  return value.endsWith('/') ? value.slice(0, -1) : value;
};

const buildBaseUrl = () => {
  const explicit = sanitizeBase(DJANGO_API_URL || API_URL || '');
  if (!explicit) {
    return '/api/v1';
  }
  // Standardize trailing slashes
  return explicit.endsWith('/api/v1') ? explicit : `${explicit}/api/v1`;
};

const axiosClient = axios.create({
  baseURL: buildBaseUrl(),
});

let tokenProvider = null;
let errorHandler = null;

export const setAxiosTokenProvider = (provider) => {
  tokenProvider = typeof provider === 'function' ? provider : null;
};

export const setAxiosErrorHandler = (handler) => {
  errorHandler = typeof handler === 'function' ? handler : null;
};

axiosClient.interceptors.request.use(
  async (config) => {
    if (tokenProvider) {
      try {
        const token = await tokenProvider();
        if (token) {
          config.headers = config.headers || {};
          config.headers.Authorization = `Bearer ${token}`;
        }
      } catch (error) {
        if (import.meta.env?.DEV) {
          console.warn('axiosClient token retrieval failed', error);
        }
      }
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axiosClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const silent = error?.config?.skipGlobalErrorHandler === true;
    if (!silent) {
      if (errorHandler) {
        errorHandler(error);
      } else {
        const message =
          error?.response?.data?.message ||
          error?.response?.data?.detail ||
          error?.message ||
          'Something went wrong. Please try again.';
        openSnackbar({
          open: true,
          message,
          variant: 'alert',
          alert: { color: 'error' },
        });
      }
    }
    return Promise.reject(error);
  }
);

export default axiosClient;
